import { Link } from 'react-router-dom';
import { Panel, PanelHeader, SectionHeading } from '@/components/ui/Panel';
import { BalancesPanel } from '@/components/finance/BalancesPanel';
import { CommissionRates } from '@/components/finance/CommissionRates';
import { WithdrawForm } from '@/components/finance/WithdrawForm';
import { WithdrawalHistory } from '@/components/finance/WithdrawalHistory';
import { LedgerTable } from '@/components/finance/LedgerTable';
import { WalletPanel, type WalletInfo } from '../../../../packages/reporting-ui/WalletPanel';
import { api } from '@/lib/api';

const loadWallet = async () => (await api.get<WalletInfo>('/traders/wallet')).data;

/**
 * Финансы — everything about the trader's money in one place.
 *
 * Reached from the balances panel on Обзор rather than from a fourth tab: the
 * bar stays at three, and this is a screen a trader visits deliberately (to
 * withdraw, or to work out where a number came from) rather than one they live
 * on.
 *
 * The order is the order of the questions: what do I have, what do I earn, how
 * do I take it out, where did my last withdrawal get to, and finally — the long
 * answer — every movement that produced those figures.
 */
export default function FinancePage() {
  return (
    <div>
      <header>
        <Link to="/reports">Отчёты и выгрузки →</Link>
        <h1 className="text-xl font-semibold tracking-tight text-fg">Финансы</h1>
        <p className="mt-1.5 max-w-prose text-sm text-fg-secondary">
          Залог, заморозка и заработок — три разные вещи. Ниже видно, сколько на каждом счёте и
          почему.
        </p>
      </header>

      <section aria-labelledby="balances-heading" className="mt-8">
        <h2 id="balances-heading" className="sr-only">
          Баланс
        </h2>
        <BalancesPanel variant="full" />
      </section>

      <WalletPanel load={loadWallet} />
      <SectionHeading>Ваша комиссия</SectionHeading>
      <Panel padding="none">
        <PanelHeader
          title="Ставки по методам"
          description="Доля платежа, которая достаётся вам. Ставку назначает администратор."
        />
        <CommissionRates />
      </Panel>

      <SectionHeading>Вывод средств</SectionHeading>
      <Panel padding="none">
        <PanelHeader
          title="Заявка на вывод"
          description="Вывести можно только заработанную комиссию. Залог и заморожённые средства обеспечивают платежи и остаются на платформе."
        />
        <div className="px-4 py-4">
          <WithdrawForm />
        </div>
      </Panel>

      <SectionHeading>История выводов</SectionHeading>
      <Panel padding="none">
        <WithdrawalHistory />
      </Panel>

      <SectionHeading>Выписка</SectionHeading>
      <Panel padding="none">
        <PanelHeader
          title="Движение средств"
          description="Каждое движение по вашим счетам, сначала новые. Если какая-то цифра выше вам непонятна — ответ здесь."
        />
        <LedgerTable />
      </Panel>
    </div>
  );
}
